import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/*
Fires when the User stops watching the Clip. Here are the different scenarios that
 satisfy this:
• When the Clip has completed its natural course.
• When the User reaches the beginning of an Ad Pod (so the current Clip is "forced" to end).
• When the User changes the channel (so the current Clip is "forced" to end).
• When the User changes sections from Live TV to either VOD or MyPluto (so the current
Clip is "forced" to end).
• When the User is in VOD and pauses the clip.
• When the User is in VOD and exits the title by force.
• When the User is in VOD and the title has naturally finished playing.

The following parameters (channel_id, episode_id, clip_id) should reflect whatever the User
is watching at the moment the Event is fired.
If in VOD mode, channel_id should simply be lowercase "vod"
 */

// eslint-disable-next-line no-unused-vars
export const clipEndBeacon = (action, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.WATCH,
  eventName: EVENT_NAMES.CLIP_END,
  ...action.payload,
});
